/**
 * ScribblesSection — "Recent Scribbles" preview (Overview) or the full
 * journal (Scribbles tab), depending on `limit`.
 */

import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { SectionHeader } from '@/components/site/primitives';
import { stagger, viewport } from '@/lib/motion';
import ScribbleCard from './ScribbleCard';
import EmptyState from './EmptyState';
import { PROFILE } from '@/constants/testIds';

export default function ScribblesSection({ scribbles, authorName, onToggleLike, limit, onViewAll }) {
  const visible = limit ? scribbles.slice(0, limit) : scribbles;

  return (
    <section className="u-container mt-16 md:mt-24" data-testid={PROFILE.scribbles}>
      <div className="flex items-end justify-between gap-4">
        <SectionHeader eyebrow="The reading journal" title="Recent Scribbles" />
        {limit && scribbles.length > limit && onViewAll && (
          <button type="button" onClick={onViewAll} className="group mb-1 hidden shrink-0 items-center gap-1.5 text-sm font-semibold text-coral sm:flex">
            Read more <ArrowRight className="h-4 w-4 transition-transform duration-300 ease-soft group-hover:translate-x-1" />
          </button>
        )}
      </div>

      {visible.length === 0 ? (
        <EmptyState type="scribbles" to="/app/bookshelf" compact className="mt-2" />
      ) : (
        <motion.div variants={stagger} initial="hidden" whileInView="show" viewport={viewport} className="mt-6">
          {visible.map((scribble) => (
            <ScribbleCard key={scribble.id} scribble={scribble} authorName={authorName} onToggleLike={onToggleLike} />
          ))}
        </motion.div>
      )}

      {limit && scribbles.length > limit && onViewAll && (
        <button type="button" onClick={onViewAll} className="group mt-2 inline-flex items-center gap-1.5 text-sm font-semibold text-coral sm:hidden">
          Read more <ArrowRight className="h-4 w-4 transition-transform duration-300 ease-soft group-hover:translate-x-1" />
        </button>
      )}
    </section>
  );
}
